/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import { borderRadius } from 'polished';
import Tappable from './Tappable';

type Props = {
  onSelect: any => void,
  options: Array<*>,
  value?: any,
};

const defaultProps = {
  value: undefined,
};

const Wrapper = glamorous.div({
  borderCollapse: 'collapse',
  display: 'flex',
});

const Item = glamorous.span(
  ({ theme }) => ({
    borderColor: theme.color.white,
    borderStyle: 'solid',
    borderWidth: 1,
    padding: theme.spacing.tiny,
    '&:first-of-type': {
      ...borderRadius('left', theme.borderRadius.small),
    },
    '&:last-child': {
      ...borderRadius('right', theme.borderRadius.small),
    },
  }),
  ({ active, theme }) => (
    active ? {
      backgroundColor: theme.color.white,
      color: theme.color.basis2,
    } : {
      color: theme.color.basis4,
    }
  ),
);

function MultiSwitch({
  onSelect,
  options,
  value,
}: Props) {
  return (
    <Wrapper>
      {options.map(opt => (
        <Tappable
          key={opt.value}
          component={Item}
          active={opt.value === value}
          onTap={() => onSelect(opt.value)}
        >
          {opt.label}
        </Tappable>
      ))}
    </Wrapper>
  );
}

MultiSwitch.defaultProps = defaultProps;

export default MultiSwitch;
